/* ============================================
   Theme Scripts — LogoVoice Modular Template
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

    // ============================
    // Navbar Scroll Effect
    // ============================
    const navbar = document.getElementById('navbar');
    if (navbar) {
        function handleNavScroll() {
            if (window.scrollY > 50) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        }
        window.addEventListener('scroll', handleNavScroll, { passive: true });
    }


    // ============================
    // Active Nav Link (anchor-based)
    // ============================
    const sections = document.querySelectorAll('section[id]');
    const navLinks = document.querySelectorAll('.nav-link');

    if (sections.length && navLinks.length) {
        function updateActiveLink() {
            const scrollY = window.scrollY + 100;
            sections.forEach(section => {
                const top = section.offsetTop;
                const height = section.offsetHeight;
                const id = section.getAttribute('id');
                if (scrollY >= top && scrollY < top + height) {
                    navLinks.forEach(link => {
                        link.classList.remove('active');
                        if (link.getAttribute('href') === '#' + id) {
                            link.classList.add('active');
                        }
                    });
                }
            });
        }
        window.addEventListener('scroll', updateActiveLink, { passive: true });
    }


    // ============================
    // Mobile Navigation
    // ============================
    const navToggle = document.getElementById('navToggle');
    const navLinksEl = document.getElementById('navLinks');

    if (navToggle && navLinksEl) {
        navToggle.addEventListener('click', () => {
            navToggle.classList.toggle('active');
            navLinksEl.classList.toggle('open');
            if (!navLinksEl.classList.contains('open')) {
                navLinksEl.querySelectorAll('.nav-dropdown.open').forEach(d => d.classList.remove('open'));
            }
            document.body.style.overflow = navLinksEl.classList.contains('open') ? 'hidden' : '';
        });

        // Close mobile menu when clicking a regular nav link or megamenu tile
        navLinksEl.querySelectorAll('.nav-link:not(.nav-link--parent), .megamenu-tile').forEach(link => {
            link.addEventListener('click', () => {
                navToggle.classList.remove('active');
                navLinksEl.classList.remove('open');
                navLinksEl.querySelectorAll('.nav-dropdown.open').forEach(d => d.classList.remove('open'));
                document.body.style.overflow = '';
            });
        });

        // Megamenu mobile toggle
        navLinksEl.querySelectorAll('.nav-link--parent').forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const dropdown = btn.closest('.nav-dropdown');
                // Close other open dropdowns
                navLinksEl.querySelectorAll('.nav-dropdown.open').forEach(d => {
                    if (d !== dropdown) d.classList.remove('open');
                });
                dropdown.classList.toggle('open');
            });
        });

        function closeMobileMenu() {
            navToggle.classList.remove('active');
            navLinksEl.classList.remove('open');
            navLinksEl.querySelectorAll('.nav-dropdown.open').forEach(d => d.classList.remove('open'));
            document.body.style.overflow = '';
        }

        // ESC closes mobile menu
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && navLinksEl.classList.contains('open')) {
                closeMobileMenu();
            }
        });
    }


    // ============================
    // Scroll Progress Bar
    // ============================
    const scrollProgress = document.getElementById('scrollProgress');
    if (scrollProgress) {
        function updateScrollProgress() {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const progress = docHeight > 0 ? scrollTop / docHeight : 0;
            scrollProgress.style.transform = 'scaleX(' + progress + ')';
        }
        window.addEventListener('scroll', updateScrollProgress, { passive: true });
    }


    // ============================
    // Office Hours & Status Badge
    // ============================
    const statusBadge = document.getElementById('statusBadge');
    if (statusBadge) {
        const officeHours = {
            1: { open: '08:00', close: '16:00' },
            2: { open: '08:00', close: '18:00' },
            3: { open: '08:00', close: '16:00' },
            4: { open: '08:00', close: '18:00' },
            5: { open: '08:00', close: '14:00' },
            6: null,
            0: null
        };

        const navFooterStatus = document.querySelector('.nav-footer-status');
        const navFooterStatusText = navFooterStatus ? navFooterStatus.querySelector('.nav-footer-status-text') : null;
        const navFooterDot = navFooterStatus ? navFooterStatus.querySelector('.status-dot') : null;

        function checkOfficeStatus() {
            const now = new Date();
            const day = now.getDay();
            const hours = officeHours[day];
            const statusText = statusBadge.querySelector('.status-text');
            if (!statusText) return;

            var isOpen = false;
            var text = 'Zavřeno';

            if (!hours) {
                statusBadge.className = 'status-badge closed';
                statusText.textContent = 'Zavřeno';
            } else {
                const currentMinutes = now.getHours() * 60 + now.getMinutes();
                const openParts = hours.open.split(':').map(Number);
                const closeParts = hours.close.split(':').map(Number);
                const openMinutes = openParts[0] * 60 + openParts[1];
                const closeMinutes = closeParts[0] * 60 + closeParts[1];

                if (currentMinutes >= openMinutes && currentMinutes < closeMinutes) {
                    isOpen = true;
                    statusBadge.className = 'status-badge open';
                    const remaining = closeMinutes - currentMinutes;
                    if (remaining <= 60) {
                        text = 'Otevřeno · zavírá za ' + remaining + ' min';
                    } else {
                        text = 'Otevřeno · do ' + hours.close;
                    }
                    statusText.textContent = text;
                } else if (currentMinutes < openMinutes) {
                    statusBadge.className = 'status-badge closed';
                    text = 'Zavřeno · otevírá v ' + hours.open;
                    statusText.textContent = text;
                } else {
                    statusBadge.className = 'status-badge closed';
                    statusText.textContent = 'Zavřeno';
                }
            }

            // Update mobile nav footer status
            if (navFooterStatusText) {
                navFooterStatusText.textContent = text;
            }
            if (navFooterDot) {
                navFooterDot.style.background = isOpen ? 'var(--accent)' : 'var(--secondary)';
                if (isOpen) {
                    navFooterDot.style.boxShadow = '0 0 0 0 rgba(0, 201, 167, 0.4)';
                    navFooterDot.style.animation = 'statusPulse 2s infinite';
                } else {
                    navFooterDot.style.boxShadow = '';
                    navFooterDot.style.animation = '';
                }
            }
        }

        checkOfficeStatus();
        setInterval(checkOfficeStatus, 60000);
    }

    // Highlight today in hours table
    const hoursRows = document.querySelectorAll('.hours-row');
    if (hoursRows.length) {
        const dayIndex = new Date().getDay();
        const mapping = { 1: 0, 2: 1, 3: 2, 4: 3, 5: 4, 6: 5, 0: 6 };
        const rowIndex = mapping[dayIndex];
        if (hoursRows[rowIndex]) {
            hoursRows[rowIndex].classList.add('today');
        }
    }


    // ============================
    // Reveal on Scroll (IntersectionObserver)
    // ============================
    const revealElements = document.querySelectorAll('.reveal');
    if (revealElements.length) {
        const revealObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const delay = entry.target.dataset.delay || 0;
                    setTimeout(() => {
                        entry.target.classList.add('revealed');
                    }, delay);
                    revealObserver.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });

        // Add stagger delays
        document.querySelectorAll('.service-card.reveal').forEach((el, i) => { el.dataset.delay = i * 80; });
        document.querySelectorAll('.process-step.reveal').forEach((el, i) => { el.dataset.delay = i * 120; });
        document.querySelectorAll('.faq-item.reveal').forEach((el, i) => { el.dataset.delay = i * 80; });
        document.querySelectorAll('.pricing-card.reveal').forEach((el, i) => { el.dataset.delay = i * 100; });
        document.querySelectorAll('.blog-card.reveal').forEach((el, i) => { el.dataset.delay = i * 100; });

        revealElements.forEach(el => revealObserver.observe(el));
    }


    // ============================
    // Animated Counters
    // ============================
    const statNumbers = document.querySelectorAll('.stat-number[data-target]');
    if (statNumbers.length) {
        const counterObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    animateCounter(entry.target);
                    counterObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.5 });

        function animateCounter(el) {
            const target = parseInt(el.dataset.target);
            const duration = 2000;
            const startTime = performance.now();

            function update(currentTime) {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const eased = 1 - Math.pow(1 - progress, 3);
                el.textContent = Math.floor(eased * target).toLocaleString('cs-CZ');
                if (progress < 1) {
                    requestAnimationFrame(update);
                } else {
                    el.textContent = target.toLocaleString('cs-CZ');
                }
            }

            requestAnimationFrame(update);
        }

        statNumbers.forEach(el => counterObserver.observe(el));
    }


    // ============================
    // Floating Letters (Hero)
    // ============================
    const floatingLettersContainer = document.getElementById('floatingLetters');
    if (floatingLettersContainer) {
        const letters = 'AÁBCČDĎEÉĚFGHIÍJKLMNŇOÓPQRŘSŠTŤUÚŮVWXYÝZŽaábcčdďeéěfghiíjklmnňoópqrřsštťuúůvwxyýzž'.split('');

        function createFloatingLetters() {
            const count = Math.min(20, Math.floor(window.innerWidth / 80));
            floatingLettersContainer.innerHTML = '';
            for (var i = 0; i < count; i++) {
                var span = document.createElement('span');
                span.className = 'floating-letter';
                span.textContent = letters[Math.floor(Math.random() * letters.length)];
                span.style.setProperty('--duration', (8 + Math.random() * 12) + 's');
                span.style.setProperty('--delay', (-Math.random() * 10) + 's');
                span.style.left = (Math.random() * 100) + '%';
                span.style.top = (Math.random() * 100) + '%';
                span.style.fontSize = (1.5 + Math.random() * 3) + 'rem';
                floatingLettersContainer.appendChild(span);
            }
        }

        createFloatingLetters();
        var resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(createFloatingLetters, 300);
        });
    }


    // ============================
    // FAQ Accordion
    // ============================
    document.querySelectorAll('.faq-question').forEach(button => {
        button.addEventListener('click', () => {
            const item = button.parentElement;
            const isActive = item.classList.contains('active');

            document.querySelectorAll('.faq-item.active').forEach(activeItem => {
                if (activeItem !== item) {
                    activeItem.classList.remove('active');
                    activeItem.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
                }
            });

            item.classList.toggle('active', !isActive);
            button.setAttribute('aria-expanded', !isActive);
        });
    });


    // ============================
    // Reviews Slider
    // ============================
    const reviewsTrack = document.getElementById('reviewsTrack');
    const reviewPrev = document.getElementById('reviewPrev');
    const reviewNext = document.getElementById('reviewNext');
    const reviewsDots = document.getElementById('reviewsDots');

    if (reviewsTrack && reviewPrev && reviewNext && reviewsDots) {
        const reviewCards = reviewsTrack.querySelectorAll('.review-card');
        var currentReview = 0;
        var reviewsPerView = 3;
        var totalPages = 1;

        function updateReviewsPerView() {
            var width = window.innerWidth;
            if (width <= 768) {
                reviewsPerView = 1;
            } else if (width <= 1024) {
                reviewsPerView = 2;
            } else {
                reviewsPerView = 3;
            }
            totalPages = Math.max(1, reviewCards.length - reviewsPerView + 1);
            currentReview = Math.min(currentReview, totalPages - 1);
            buildDots();
            updateSlider();
        }

        function buildDots() {
            reviewsDots.innerHTML = '';
            for (var i = 0; i < totalPages; i++) {
                var dot = document.createElement('span');
                dot.className = 'dot' + (i === currentReview ? ' active' : '');
                dot.addEventListener('click', (function(idx) {
                    return function() {
                        currentReview = idx;
                        updateSlider();
                    };
                })(i));
                reviewsDots.appendChild(dot);
            }
        }

        function updateSlider() {
            var card = reviewCards[0];
            if (!card) return;
            var gap = 24;
            var cardWidth = card.offsetWidth + gap;
            reviewsTrack.style.transform = 'translateX(-' + (currentReview * cardWidth) + 'px)';
            reviewsDots.querySelectorAll('.dot').forEach(function(dot, i) {
                dot.className = 'dot' + (i === currentReview ? ' active' : '');
            });
        }

        reviewPrev.addEventListener('click', () => {
            currentReview = Math.max(0, currentReview - 1);
            updateSlider();
        });

        reviewNext.addEventListener('click', () => {
            currentReview = Math.min(totalPages - 1, currentReview + 1);
            updateSlider();
        });

        // Touch/swipe
        var touchStartX = 0;
        reviewsTrack.addEventListener('touchstart', (e) => {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        reviewsTrack.addEventListener('touchend', (e) => {
            var diff = touchStartX - e.changedTouches[0].screenX;
            if (Math.abs(diff) > 50) {
                if (diff > 0) {
                    currentReview = Math.min(totalPages - 1, currentReview + 1);
                } else {
                    currentReview = Math.max(0, currentReview - 1);
                }
                updateSlider();
            }
        }, { passive: true });

        updateReviewsPerView();
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(updateReviewsPerView, 200);
        });
    }


    // ============================
    // Back to Top Button
    // ============================
    const backToTop = document.getElementById('backToTop');
    if (backToTop) {
        const bttCircle = document.getElementById('bttCircle');
        const circumference = 2 * Math.PI * 22;

        function updateBackToTop() {
            var scrollTop = window.scrollY;
            var docHeight = document.documentElement.scrollHeight - window.innerHeight;
            var progress = docHeight > 0 ? scrollTop / docHeight : 0;

            if (scrollTop > 400) {
                backToTop.classList.add('visible');
            } else {
                backToTop.classList.remove('visible');
            }

            if (bttCircle) {
                bttCircle.style.strokeDashoffset = circumference - (progress * circumference);
            }
        }

        window.addEventListener('scroll', updateBackToTop, { passive: true });

        backToTop.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }


    // ============================
    // Timeline Line Animation
    // ============================
    const timelineLine = document.getElementById('timelineLine');
    if (timelineLine) {
        const timelineObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    timelineLine.classList.add('animated');
                }
            });
        }, { threshold: 0.2 });

        timelineObserver.observe(timelineLine);
    }


    // ============================
    // Smooth Scroll for Anchor Links
    // ============================
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            var target = document.querySelector(this.getAttribute('href'));
            if (target) {
                e.preventDefault();
                target.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });


    // ============================
    // Copy Link Button
    // ============================
    var copyBtn = document.querySelector('.share-copy[data-url]');
    if (copyBtn) {
        copyBtn.addEventListener('click', function () {
            var url = this.dataset.url;
            var icon = this.querySelector('i');
            navigator.clipboard.writeText(url).then(function () {
                icon.className = 'fa-light fa-check';
                copyBtn.classList.add('copied');
                setTimeout(function () {
                    icon.className = 'fa-light fa-link';
                    copyBtn.classList.remove('copied');
                }, 2000);
            });
        });
    }


    // ============================
    // Service Card Tilt Effect
    // ============================
    if (window.matchMedia('(hover: hover)').matches) {
        document.querySelectorAll('[data-tilt]').forEach(card => {
            card.addEventListener('mousemove', (e) => {
                var rect = card.getBoundingClientRect();
                var x = e.clientX - rect.left;
                var y = e.clientY - rect.top;
                var centerX = rect.width / 2;
                var centerY = rect.height / 2;
                var rotateX = (y - centerY) / centerY * -3;
                var rotateY = (x - centerX) / centerX * 3;
                card.style.transform = 'perspective(1000px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-6px)';
            });

            card.addEventListener('mouseleave', () => {
                card.style.transform = '';
            });
        });
    }

});
